'use client'

import type { MenuItem, MenuSeparator, NavGroup } from '@graftcode/design-system'

import { AppVariant } from '../../../../enums'
import { BaseMobileMenu } from '../../BaseMobileMenu'

interface ModulesMobileMenuProps {
  isOpen: boolean
  onClose: () => void
  menuGroups: NavGroup[]
  helpItems?: (MenuItem | MenuSeparator)[]
  onProfileClick?: (itemId: string) => void
  onHelpClick?: (itemId: string) => void
  onNavigationClick?: (url: string) => void
  onProjectClick?: (projectId: string) => void
  onWorkspaceClick?: (workspaceId: string) => void
  onOpenWorkspaceSettings?: () => void
  onOpenProjectSettings?: () => void
  onOpenProjectMembers?: () => void
  onInviteProjectClick?: () => void
  onInviteWorkspaceClick?: () => void
  onCreateProject?: () => void
  notificationBadge?: number
  onNotificationClick?: () => void
}

export function ModulesMobileMenu({
  isOpen,
  onClose,
  menuGroups,
  helpItems,
  onProfileClick,
  onHelpClick,
  onNavigationClick,
  onProjectClick,
  onWorkspaceClick,
  onOpenWorkspaceSettings,
  onOpenProjectSettings,
  onOpenProjectMembers,
  onInviteProjectClick,
  onInviteWorkspaceClick,
  onCreateProject,
  notificationBadge,
  onNotificationClick,
}: ModulesMobileMenuProps) {
  return (
    <BaseMobileMenu
      isOpen={isOpen}
      onClose={onClose}
      appVariant={AppVariant.MODULES}
      menuGroups={menuGroups}
      helpItems={helpItems}
      onProfileClick={onProfileClick}
      onHelpClick={onHelpClick}
      onNavigationClick={onNavigationClick}
      onProjectClick={onProjectClick}
      onWorkspaceClick={onWorkspaceClick}
      onOpenWorkspaceSettings={onOpenWorkspaceSettings}
      onOpenProjectSettings={onOpenProjectSettings}
      onOpenProjectMembers={onOpenProjectMembers}
      onInviteProjectClick={onInviteProjectClick}
      onInviteWorkspaceClick={onInviteWorkspaceClick}
      onCreateProject={onCreateProject}
      notificationBadge={notificationBadge}
      onNotificationClick={onNotificationClick}
    />
  )
}
